import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const DataMappingServiceConfig = {
  name: "DataMapping",
  annotations: []
} as ServiceConfig;